// extracted by mini-css-extract-plugin
module.exports = {"container":"note_container__3YHAx","blueVariant":"note_blueVariant__NMJFO","paragraph":"note_paragraph__2e6-_"};